module Omni.Core {
    export let ngModule = angular.module("omni.core", []);

    class CacheFactoryProvider {
        static $inject = ["CacheFactoryProvider"];

        constructor(cacheFactoryProvider) {
            angular.extend(cacheFactoryProvider.defaults, { maxAge: 15 * 60 * 1000 });
        }
    }

    class LogProviderConfig {
        static $inject = ["$logProvider", "appConfig"];

        constructor($logProvider: ng.ILogProvider, appConfig: Core.Constants.IAppConfig) {
            $logProvider.debugEnabled(appConfig.DebugMode);
        }
    }

    class QProviderConfig {
        static $inject = ["$qProvider"];

        constructor($qProvider: ng.IQProvider) {
            // This may suppress errors with promises not having error (catch) handlers.
            $qProvider.errorOnUnhandledRejections(false);
        }
    }

    class CompileProviderConfig {
        static $inject = ["$compileProvider", "appConfig"];

        constructor($compileProvider: ng.ICompileProvider, appConfig: Core.Constants.IAppConfig) {
          // See https://docs.angularjs.org/guide/production for references
          $compileProvider.debugInfoEnabled(appConfig.DebugMode);
          // Disables comment directives ('M'), this speeds up compilation
          $compileProvider.commentDirectivesEnabled(false);
          // Due to resort map legacy code, we cannot disable css class directives ('C'), see https://docs.angularjs.org/guide/directive for references
          $compileProvider.cssClassDirectivesEnabled(true);
        }
    }

    function momentFactory($window: any) {
        return $window.moment;
    }
    momentFactory.$inject = ["$window"];

    ngModule.config(QProviderConfig);
    ngModule.config(CacheFactoryProvider);
    ngModule.config(LogProviderConfig);
    ngModule.config(CompileProviderConfig);
    ngModule.factory("moment", momentFactory);
}
